import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import DlUnitEl from "./DlUnitEl";
import axios from "axios";
import dlCommon from "../../dlCommon";
import "./DlUnitLi.scss";
import { getUnitLi } from "./../../actions";
import DlUnitLiNav from "./DlUnitLiNav";
import DlUnitSearch from "./DlUnitSearch";
import AddNew from "./AddNew";
import DlUnitFileFields from "./DlUnitFileFields";

const mapStateToProps = (state) => ({
  dlUnitN: state.dlUnitLi.dlUnitN,
});

const mapDispatchToProps = (dispatch) => ({
  getUnitLi: (payload) => dispatch(getUnitLi(payload)),
});

const DlUnitLi = ({ dlUnitN, getUnitLi }) => {
  const hmCh = () => {
    let ch = true;
    return ch;
  };

  const cond = !hmCh() ? {} : { uType: "HM2" };
  const dlUnitMaxPerPage = 20;
  useEffect(function () {
    getUnitLi({ dlUnitCond: cond, dlUnitMaxPerPage });
  }, []);

  const removeItem = (id) => {
    console.log("removeItem");
    try {
      let res;
      const url = dlCommon.apiUrlGet("dl-unit", id);
      res = axios.delete(url);
    } catch (error) {
      console.log(error);
    }
  };

  let itemN = [];
  itemN = dlUnitN.map((item, ind) => (
    <DlUnitEl key={ind} item={item} id={item.id} ind={ind} dispType="adm" />
  ));

  let addInfo = "";
  if (dlUnitN.length == 0) {
    addInfo = <div>Nema rezultata pretraživanja</div>;
  }

  return (
    <div>
      <DlUnitSearch />
      <DlUnitLiNav />
      <DlUnitFileFields />
      <AddNew
        adr={"/admin-dashboard/dl-unit-edit"}
        addStyle={{ marginTop: "1em" }}
      />
      {itemN}
      {addInfo}
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(DlUnitLi);
